import { render, staticRenderFns } from "./CardPieChart.vue?vue&type=template&id=6c163b64"
import script from "./CardPieChart.vue?vue&type=script&lang=js"
export * from "./CardPieChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports